// Home.tsx
import React from 'react';
import Hero from '../components/Hero/Hero';
import Pathfinder from '../components/Pathfinder/Pathfinder';
import Metadata from '../components/Metadata/Metadata';
import Card from '../components/Card/Card';
import Wallpaper from '../components/Wallpaper/Wallpaper';
import ContentSplit from '../components/ContentSplit/ContentSplit';
import ListItem from '../components/ListItem/ListItem';
import Section from '../components/Section/Section';
import Image from '../components/Image/Image';
import Button from '../components/Button/Button';
import Accordion from '../components/Accordion/Accordion';
import Media from '../components/Media/Media';
import Video from '../components/Video/Video';

import awards from '../assets/images/objects/awards.svg';

const Home: React.FC = () => {
  return (
    <div>
      <Metadata
        title="Synthetic Data (SYN46™) Solutions for Government"
        description="Discover secure synthetic data (SYN46™) solutions tailored for government needs. General Genomics delivers compliant, AI-powered innovations for public sector challenges."
      />
      <Hero
        id="page-hero"
        headline="AI-powered synthetic and de-identified data solutions for government and commercial sectors"
      >
        <div id="home-hero-card-wrapper">
          <p className="industry-select action-on-view action-fade-in action-delay-250">
            Select your industry to discover tailored data solutions.
          </p>
          <div className="card-group">
            <Card
              icon="assured_workload"
              headline="Government Solutions"
              subhead="Data-driven solutions supporting federal, state, and local agencies."
              id="home-hero-card-primary"
              type="home-hero"
              btnLabel="Government Data Solutions"
              btnURL="/industries/government"
              className="action-on-view action-fade-in action-delay-500"
            />
            <Card
              icon="domain"
              headline="Commercial Solutions"
              subhead="Scalable data solutions for diverse commercial applications."
              id="home-hero-card-secondary"
              type="home-hero"
              btnLabel="Commercial Data Solutions"
              btnURL="/industries/commercial"
              className="action-on-view action-fade-in action-delay-750"
            />
          </div>
        </div>
      </Hero>

      <ContentSplit
        image="/images/library/office.webp"
        position="left"
        className="alt-bkg"
      >
        <p className="helper action-on-view action-fade-in">Our Core Values</p>
        <h2 className="action-on-view action-fade-in">
          Driving Integrity, Innovation, and Impact in Every Solution
        </h2>
        <p className="action-on-view action-fade-in">
          Drive efficiency and impact with tailored solutions designed to
          optimize complex systems and maintain operational readiness.
        </p>
        <ListItem
          icon="check"
          iconClass="highlighted-icon"
          className="custom-list-item"
        >
          <p>
            <strong>Innovation:</strong> Embracing advancements in AI and
            machine learning.
          </p>
        </ListItem>
        <ListItem
          icon="check"
          iconClass="highlighted-icon"
          className="custom-list-item"
        >
          <p>
            <strong>Innovation:</strong> Embracing advancements in AI and
            machine learning.
          </p>
        </ListItem>
        <ListItem
          icon="check"
          iconClass="highlighted-icon"
          className="custom-list-item"
        >
          <p>
            <strong>Innovation:</strong> Embracing advancements in AI and
            machine learning.
          </p>
        </ListItem>
        <ListItem
          icon="check"
          iconClass="highlighted-icon"
          className="custom-list-item"
        >
          <p>
            <strong>Innovation:</strong> Embracing advancements in AI and
            machine learning.
          </p>
        </ListItem>
      </ContentSplit>

      <Wallpaper asset="/images/library/capital-building-digital.webp"></Wallpaper>

      <Section theme="" className="cards-large-icons">
        <h2 className="action-on-view action-fade-in">
          Advanced Data Solutions for Bioscience and Logistics
        </h2>
        <p className="action-on-view action-fade-in">
          Empowering bioscience and logistical operations with secure,
          data-driven advancements that support both government and commercial
          needs.
        </p>
        <Image
          path="/images/library/architecture-windows-building.webp"
          size="wide"
          className="action-on-view action-fade-in"
          alt="This is a wide image."
        />
        <div className="card-group">
          <Card
            icon="shield_locked"
            headline="Supply Chain and Logistics Management"
            subhead="Our bioinformatics-based AI solutions help manage risks and streamline supply chains, ensuring secure, continuous operations even in challenging environments."
            btnURL="/"
            btnLabel="Learn more"
            className="action-on-view action-fade-in"
          />
          <Card
            icon="database"
            headline="Genomic Research and Bioinformatics"
            subhead="Our capabilities in bioscience and bioinformatics support advanced research initiatives, enabling government and commercial clients to leverage data for strategic decision-making and innovation."
            btnURL="/"
            btnLabel="Learn more"
            className="action-on-view action-fade-in"
          />
        </div>
      </Section>

      <Section theme="dark" className="">
        <h2 className="action-on-view action-fade-in">
          Advanced Data Solutions for Bioscience and Logistics
        </h2>
        <p className="action-on-view action-fade-in">
          Empowering bioscience and logistical operations with secure,
          data-driven advancements that support both government and commercial
          needs.
        </p>
        <Image
          path="/images/library/capital-building-digital.webp"
          size="wide"
          className="action-on-view action-fade-in"
          alt="This is a wide image."
        />
        <div className="card-group">
          <Card
            icon="shield_locked"
            headline="Supply Chain and Logistics Management"
            subhead="Our bioinformatics-based AI solutions help manage risks and streamline supply chains, ensuring secure, continuous operations even in challenging environments."
            btnURL="/"
            btnLabel="Learn more"
            className="action-on-view action-fade-in"
          />
          <Card
            icon="database"
            headline="Genomic Research and Bioinformatics"
            subhead="Our capabilities in bioscience and bioinformatics support advanced research initiatives, enabling government and commercial clients to leverage data for strategic decision-making and innovation."
            btnURL="/"
            btnLabel="Learn more"
            className="action-on-view action-fade-in"
          />
        </div>
      </Section>

      <Section theme="" bgName="lines" className="section-call-to-action">
        <h2 className="action-on-view action-fade-in">
          Connect with Us for Secure, Scalable Data Solutions
        </h2>
        <p className="action-on-view action-fade-in">
          Are you ready to explore how our team and technology can enhance your
          data initiatives? Contact us today to learn more about our solutions
          and how we can bring value to your agency or organization.
        </p>
        <Button
          className="action-on-view action-fade-in"
          url="/"
          label="Get in touch"
        />
      </Section>

      <Section theme="dark" className="cards-large-icons">
        <h2 className="action-on-view action-fade-in">
          Advanced Data Solutions for Bioscience and Logistics
        </h2>
        <p className="action-on-view action-fade-in">
          Empowering bioscience and logistical operations with secure,
          data-driven advancements that support both government and commercial
          needs.
        </p>
        <div className="card-group card-max-row-4">
          <Card
            iconImage={awards}
            headline="ISO 9001 Certified"
            subhead="Recognized for our quality management systems, ensuring consistent quality in our genomic services."
            className="action-on-view action-fade-in"
          />
          <Card
            iconImage={awards}
            headline="CLIA Certified"
            subhead="Recognized for our quality management systems, ensuring consistent quality in our genomic services."
            className="action-on-view action-fade-in"
          />
          <Card
            iconImage={awards}
            headline="CLIA Certified"
            subhead="Recognized for our quality management systems, ensuring consistent quality in our genomic services."
            className="action-on-view action-fade-in"
          />
          <Card
            iconImage={awards}
            headline="CLIA Certified"
            subhead="Recognized for our quality management systems, ensuring consistent quality in our genomic services."
            className="action-on-view action-fade-in"
          />
          <Card
            iconImage={awards}
            headline="CLIA Certified"
            subhead="Recognized for our quality management systems, ensuring consistent quality in our genomic services."
            className="action-on-view action-fade-in"
          />
          <Card
            iconImage={awards}
            headline="CLIA Certified"
            subhead="Recognized for our quality management systems, ensuring consistent quality in our genomic services."
            className="action-on-view action-fade-in"
          />
        </div>
      </Section>

      <Section theme="" className="">
        <h2 className="action-on-view action-fade-in">
          Frequently Asked Questions about Government Data Solutions
        </h2>
        <p className="action-on-view action-fade-in">
          Everything you need to know about the product and billing.
        </p>
        <div className="accordion-wrapper action-on-view action-fade-in">
          <Accordion headline="What measures do you take to ensure government data security and privacy?">
            Our solutions are built on secure cloud infrastructure with advanced
            encryption and strict access controls to safeguard data integrity
            and confidentiality. We meet or exceed industry standards such as
            HIPAA, GDPR, and government-specific security protocols, ensuring
            full compliance with all regulatory requirements.
          </Accordion>
          <Accordion headline="How can I request a demo?">
            Contact us at sales@ggenomics.com to schedule a demo.
          </Accordion>
        </div>
      </Section>

      <Section theme="dark" bgName="lines" className="section-call-to-action">
        <h2 className="action-on-view action-fade-in">
          Why partner with General Genomics for Pharmaceutical data solutions?
        </h2>
        <div className="card-group">
          <Card
            icon="check"
            headline="Expertise"
            subhead="Our team comprises professionals with extensive experience in pharmaceuticals, data science, and AI technologies."
            className="action-on-view action-fade-in"
          />
          <Card
            icon="check"
            headline="Innovation"
            subhead="We leverage cutting-edge technologies to develop solutions that address complex challenges in drug development and patient care."
            className="action-on-view action-fade-in action-delay-250"
          />
          <Card
            icon="check"
            headline="Commitment"
            subhead="We are dedicated to advancing healthcare by providing solutions that improve efficiency, reduce costs, and enhance patient outcomes."
            className="action-on-view action-fade-in action-delay-250"
          />
        </div>
        <Button
          className="action-on-view action-fade-in button-size-large"
          url="/"
          label="Get in touch"
        />
      </Section>

      <Section theme="" className="section-media">
        <h2>Stay Updated with the Latest News and Announcements</h2>
        <p>
          Explore our collection of press releases and news articles
          highlighting General Genomics&apos; achievements, partnerships, and
          innovations. Stay informed on how we are advancing AI, data solutions,
          and industry-leading practices.
        </p>
        <Media />
      </Section>

      <Section theme="" className="section-video">
        <h2>Stay Updated with the Latest News and Announcements</h2>
        <p>
          Explore our collection of press releases and news articles
          highlighting General Genomics&apos; achievements, partnerships, and
          innovations. Stay informed on how we are advancing AI, data solutions,
          and industry-leading practices.
        </p>
        <Video
          videoID="dQw4w9WgXcQ"
          platform="youtube"
          className="custom-video"
        />
        <Video videoID="405855071" platform="vimeo" />
      </Section>

      <Section>
        <ContentSplit image="/images/placeholder.jpg" position="left">
          <h2 className="action-on-view action-fade-in">
            Our Mission and Vision
          </h2>
          <p className="action-on-view action-fade-in">
            General Genomics was founded on the belief that data has the power
            to solve humanity’s greatest challenges. As a Service-Disabled
            Veteran-Owned Small Business, our mission is rooted in national
            security and the advancement of groundbreaking AI and ML solutions.
            From enhancing military operations to streamlining healthcare
            logistics, we are dedicated to creating innovative systems that
            improve efficiency, reduce risks, and support our clients’ critical
            missions.
          </p>
        </ContentSplit>
      </Section>

      <Section>
        <ContentSplit image="/images/placeholder.jpg" position="right">
          <h2 className="action-on-view action-fade-in">
            Curo46®: A Revolution in AI
          </h2>
          <p className="action-on-view action-fade-in">
            Our flagship platform, Curo46®, stands at the intersection of
            biology and technology. Designed to analyze both biological and
            man-made systems, Curo46® harnesses proprietary data and LLMs to
            deliver actionable insights. It empowers industries with predictive
            health risk management, supply chain optimization, and advanced
            cybersecurity measures, setting a new standard in AI-driven
            innovation.
          </p>
        </ContentSplit>
      </Section>

      <Section>
        <ContentSplit image="/images/placeholder.jpg" position="left">
          <h2 className="action-on-view action-fade-in">
            AI-Driven National Security
          </h2>
          <p className="action-on-view action-fade-in">
            At the heart of our operations is a commitment to safeguarding the
            nation. General Genomics develops cutting-edge AI and ML
            technologies to support joint forces, enabling decisive action
            against emerging threats. From counter-drone capabilities to human
            performance optimization, our solutions are crafted to ensure
            mission readiness and operational superiority.
          </p>
        </ContentSplit>
      </Section>

      <Section>
        <ContentSplit image="/images/placeholder.jpg" position="right">
          <h2 className="action-on-view action-fade-in">
            Health Informatics and Predictive Analytics
          </h2>
          <p className="action-on-view action-fade-in">
            Beyond national defense, General Genomics is transforming healthcare
            through AI-driven precision medicine, remote health monitoring, and
            predictive analytics. Our solutions empower medical professionals to
            deliver better outcomes by optimizing workflows, enhancing
            decision-making, and advancing genomic research. We’re not just
            innovating—we’re healing the world.
          </p>
        </ContentSplit>
      </Section>

      <Section>
        <ContentSplit image="/images/placeholder.jpg" position="left">
          <h2 className="action-on-view action-fade-in">
            Our Leadership: AJ Rosenthal
          </h2>
          <p className="action-on-view action-fade-in">
            Led by decorated combat veteran AJ Rosenthal, General Genomics
            blends expertise in engineering, business development, and
            leadership. With over 20 years of experience, AJ’s vision guides our
            mission to harness data and AI for global impact. His dedication to
            innovation and service ensures that General Genomics remains at the
            forefront of solving the world’s most complex challenges.
          </p>
        </ContentSplit>
      </Section>

      <Section>
        <ContentSplit
          image="/images/library/command-center-group-2.webp"
          position="left"
          className="valign-top"
        >
          <p className="helper action-on-view action-fade-in">
            Medical AI Capabilities
          </p>
          <h2 className="action-on-view action-fade-in">
            Health and Medical Capabilities for Operational Readiness
          </h2>
          <p className="action-on-view action-fade-in">
            General Genomics, Inc. leverages AI, genomics, and telemedicine to
            enhance healthcare outcomes, support military readiness, and drive
            precision treatments through innovative technologies.
          </p>
          <div className="accordion-wrapper action-on-view action-fade-in">
            <Accordion
              headline={
                <>
                  Health Informatics and Predictive Analytics
                  <em>
                    NAICS Code 541511: Custom Computer Programming Services
                  </em>
                </>
              }
            >
              <p>
                General Genomics, Inc. (GGI) enhances healthcare outcomes
                through advanced AI-driven predictive analytics. Leveraging our
                proprietary data lake with over 600 million records, we provide
                early health issue detection and optimize medical readiness. Our
                predictive algorithms support proactive health management,
                ensuring forces remain in peak condition and enhancing
                operational readiness.
              </p>
              <p>
                We have three patents pending that are centered on innovative
                machine learning technology designed to identify illnesses and
                diseases across all living organisms, from bacteria to humans.
              </p>
            </Accordion>
            <Accordion
              headline={
                <>
                  Precision Medicine and Genomic Research{' '}
                  <em>
                    NAICS Code 541714: Research and Development in Biotechnology
                  </em>
                </>
              }
            >
              <p>
                General Genomics drives precision medicine and genomic research
                by analyzing extensive data from our proprietary data lake. Our
                tailored medical treatments based on individual genetic profiles
                offer highly personalized healthcare solutions, improving
                recovery rates and overall health for military personnel, thus
                supporting sustained force preservation.
              </p>
              <p>
                We have three patents pending that are centered on innovative
                machine learning technology designed to identify illnesses and
                diseases across all living organisms, from bacteria to humans.
              </p>
            </Accordion>
            <Accordion
              headline={
                <>
                  Clinical Decision Support Systems{' '}
                  <em>
                    NAICS Code 541513: Computer Facilities Management Services
                  </em>
                </>
              }
            >
              <p>
                General Genomics enhances clinical decision-making with
                sophisticated decision support systems powered by AI. Our
                solutions, informed by a vast clinical data repository, assist
                healthcare providers in delivering accurate, data-driven care.
                This ensures optimal outcomes and maintains the operational
                effectiveness of military and civilian health services.
              </p>
              <p>
                We have three patents pending that are centered on innovative
                machine learning technology designed to identify illnesses and
                diseases across all living organisms, from bacteria to humans.
              </p>
            </Accordion>
            <Accordion
              headline={
                <>
                  Remote Health Monitoring and Telemedicine{' '}
                  <em>
                    NAICS Code 621999: All Other Miscellaneous Ambulatory Health
                    Care Services
                  </em>
                </>
              }
            >
              <p>
                We provide cutting-edge remote health monitoring and
                telemedicine solutions through AI/ML technologies. General
                Genomics offers real-time health insights and virtual
                consultations, ensuring continuous healthcare support for
                deployed and remote personnel, which is crucial for maintaining
                their health and operational effectiveness.
              </p>
            </Accordion>
            <Accordion
              headline={
                <>
                  AI/ML-Driven Drug Development and Therapeutics{' '}
                  <em>
                    NAICS Code 541714: Research and Development in Biotechnology
                  </em>
                </>
              }
            >
              <p>
                General Genomics accelerates drug development and therapeutics
                with AI/ML technologies. Our extensive data lake enables the
                identification of novel drug targets and optimization of
                therapeutic regimens, enhancing recovery and health outcomes for
                military personnel, thus supporting operational readiness.
              </p>
              <p>
                We have three patents pending that are centered on innovative
                machine learning technology designed to identify illnesses and
                diseases across all living organisms, from bacteria to
                humans.{' '}
              </p>
            </Accordion>
          </div>
        </ContentSplit>
      </Section>

      <Section theme="" className="cards-large-icons">
        <h2 className="action-on-view action-fade-in">
          Proudly Recognized by the U.S. Small Business Administration
        </h2>
        <p className="action-on-view action-fade-in">
          Certified as a Service-Disabled Veteran-Owned Business and honored as
          a 2024 Growth Accelerator Fund Competition Awardee.
        </p>
        <div className="card-group card-max-row-4">
          <Card
            iconImage="/images/placeholder.jpg"
            className="action-on-view action-fade-in"
          />
          <Card
            iconImage="/images/placeholder.jpg"
            className="action-on-view action-fade-in"
          />
        </div>
      </Section>

      <Section>
        <ContentSplit
          image="/images/library/command-center-group-2.webp"
          position="left"
          className="valign-top"
        >
          <p className="helper action-on-view action-fade-in">Mapped NAICS</p>
          <h2 className="action-on-view action-fade-in">
            Mapped NAICS for Targeted AI/ML Solutions
          </h2>
          <p className="action-on-view action-fade-in">
            Leveraging mapped NAICS codes to deliver AI/ML-driven innovations
            tailored to meet industry-specific challenges and enhance
            operational outcomes.
          </p>
          <div className="list-datarow-wrapper">
            <ListItem
              listtype="datarow"
              bullet="518210"
              className="custom-list-item"
            >
              Computing Infrastructure Providers, Data Processing, Web Hosting,
              and Related Services
            </ListItem>
            <ListItem
              listtype="datarow"
              bullet="541330"
              className="custom-list-item"
            >
              Engineering Services
            </ListItem>
          </div>
        </ContentSplit>
      </Section>

      <Pathfinder />
    </div>
  );
};

export default Home;
